export enum EmergencyMode {
    Normal,
    Emergency,
    EmergencyAll,
}

export enum ControlMode {
    Auto,
    Remote,
}

export enum SelectorMode {
    Local,
    Remote,
}

export enum DriveMode {
    Manual,
    Auto,
    Remote,
}

export function driveModeToPriority(mode: DriveMode) {
    switch (mode) {
        case DriveMode.Manual:
            return 3;
        case DriveMode.Remote:
            return 2;
        case DriveMode.Auto:
            return 1;
    }
}

export function isDriveModePriorThan(lhs: DriveMode, rhs: DriveMode) {
    return driveModeToPriority(lhs) > driveModeToPriority(rhs);
}

export enum Blinker {
    Left,
    Right,
    Hazard,
}

export enum Gear {
    P = 'P', N = 'N', D = 'D', R = 'R',
}

export interface DriveCommand {
    steering: number;
    accel: number;
    brake: number;
    gear: Gear;
    blinker: Blinker | null;
    controlMode: ControlMode;
    emergency: EmergencyMode;
}
